<template>
  <div class="alert-bell-container">
    <v-icon class="notification-icon">fas fa-bell</v-icon>
    <span class="alert-counter">{{ notifs.length }}</span>
  </div>
</template>

<script lang="ts">
import Notif from "@/generated/classes/Notif";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  props: {
    notifs: {
      type: Array as PropType<Notif[]>,
      required: true
    }
  }
})

</script>